import i18n from '@/i18n';

const $t = (text) => {
  return i18n.global.t(text);
};

export const eventStatus = [
  {
    id: 'productTypeCode',
    text: $t('searchLabel.productType'),
    value: 'productTypeCode',
    width: 180,
    minWidth: 100,
    sortable: true,
    defaultValue: '-',
    isVisible: true,
    isDefault: true,
    isFixed: true,
    fixed: 'left'
  },
  {
    id: 'productName',
    text: $t('searchLabel.productName'), // 모니터링 대상
    value: 'productName',
    width: 310,
    minWidth: 100,
    sortable: true,
    defaultValue: '-',
    isVisible: true,
    isDefault: true,
    isFixed: true,
    fixed: 'left'
  },
  {
    id: 'productIpAddress',
    text: $t('searchLabel.productIpAddress'), // IP 주소
    value: 'productIpAddress',
    width: 148,
    sortable: true,
    defaultValue: '-',
    isVisible: false
  },
  {
    id: 'productState',
    text: $t('searchLabel.productState'), // 이벤트 유형
    value: 'productState',
    width: 139,
    sortable: true,
    defaultValue: '-',
    isVisible: true
  },
  {
    id: 'eventState',
    text: $t('searchLabel.eventType'), // 이벤트 유형
    value: 'eventState',
    width: 126,
    bodyAlign: 'center',
    sortable: true,
    defaultValue: '-',
    isVisible: true
  },
  {
    id: 'eventLevel',
    text: $t('searchLabel.eventLevel'), // 이벤트 위험도
    value: 'eventLevel',
    width: 125,
    bodyAlign: 'center',
    sortable: true,
    isVisible: true
  },
  {
    id: 'eventMessage',
    text: $t('searchLabel.msg'), // 메시지
    value: 'eventMessage',
    sortable: true,
    defaultValue: '-',
    isVisible: true
  },
  {
    id: 'startDt',
    text: $t('label.occurrenceTime'), // 발생시각
    value: 'startDt',
    sortable: true,
    width: 170,
    isVisible: true
  },
  {
    id: 'durationSecond',
    text: $t('label.duringTime'), // 지속시간
    value: 'durationSecond',
    sortable: true,
    width: 157,
    isVisible: true
  },
  {
    id: 'vmState',
    text: $t('searchLabel.vmState'), // vm 상태
    value: 'vmState',
    width: 120,
    sortable: true
  },
  {
    id: 'dbVersion',
    text: $t('searchLabel.dbVersion'), // db 버전
    value: 'dbVersion',
    width: 240,
    sortable: true
  },
  {
    id: 'vpcName',
    text: $t('searchLabel.vpcName'), //'LB명',
    value: 'vpcName',
    width: 240,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'lbSize',
    text: $t('searchLabel.lbSize'), //'LB명',
    value: 'lbSize',
    width: 140,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'connectedVPC',
    text: $t('searchLabel.connectedVPC'), //'연결VPC',
    value: 'connectedVPC',
    width: 240,
    sortable: true,
    defaultValue: ''
  },
  {
    id: 'diskType',
    text: $t('searchLabel.diskType'), //'이벤트 위험도',
    value: 'diskType',
    width: 132,
    sortable: true,
    bodyAlign: 'center',
  }
];
